import Http from './http';

const prefix = '/user-lottie-files';

export const getLottieFiles = () => Http.authApi().get(`${prefix}`);

export const get = ({ id }) => Http.authApi().get(`${prefix}/${id}`);

export const createLottieFile = lottiefile => Http.authApi().post(`${prefix}`, lottiefile);

export const editLottieFile = lottiefile =>
  Http.authApi().put(`${prefix}/${lottiefile.id}`, lottiefile);

export const excludeLottieFile = code => Http.authApi().delete(`${prefix}/${code}`);



// WEBPACK FOOTER //
// ./src/js/services/lottieFiles.js